import React, { Component } from 'react';
import { FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import PopupLink from '../../../shared-components/PopupLink/PopupLink';
import './OutlineOfCredit.less';
import _ from 'lodash';

const LOCALE_PREFIX = 'GB/components/OutlineOfCredit/OutlineOfCredit';
const V2 = 'v2';

export class OutlineOfCredit extends Component {
    static propTypes = {
        intl: intlShape.isRequired
    };

    render() {
        const { intl } = this.props;
        const outlineOfCreditVersion = V2;
        const apr = '19.9%';
        const monthlyRate = '1.658%';
        const offerThreshold = '£99';
        const minimumRepayment = '2%';

        return (
            <div className="outline-of-credit">
                <p className="secondary print-content">
                    <span className="print-content-icon print-icon" />
                    <PopupLink
                        url={`https://www.paypalobjects.com/webstatic/credit/html/outlineOfCredit${outlineOfCreditVersion}.html`}
                        className="popup print-content-link"
                        name="OutLineCreditPrint"
                    >{intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.print`})}
                    </PopupLink>
                    <span className="print-content-icon download-icon" />
                    <PopupLink
                        url={`https://www.paypalobjects.com/webstatic/credit/pdf/outlineOfCredit${outlineOfCreditVersion}.pdf`}
                        className="popup pdfLink"
                        name="OutLineCreditDownLoad"
                    >{intl.formatMessage({id: `${LOCALE_PREFIX}.applyForBmlUK.download`})}
                    </PopupLink>
                </p>
                <div className="outline-frame">
                    <div className="outline-body">
                        <div>
                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.outlineOfCreditReferSummaryBox`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.isPayPalCreditSuitableQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.isPayPalCreditSuitableAnswer`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.repayUnderCreditQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.repayUnderCreditAnswer`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.noRepaymentQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.noRepaymentAnswer`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.withdrawCreditAgreementQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.withdrawCreditAgreementAnswer`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.featuresOfProductQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.featuresOfProductAnswer`} /></p>

                            <p className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestRatesQuestion`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestRates`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestRatesMayChange`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.introductoryInterestRates`} /></p>

                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.featuresOfProductMoreInfo`} /></p>
                        </div>

                        <a name="summaryBox" />

                        <p><strong><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.summaryBoxTitle`} /></strong></p>

                        <div className="summaryBox" tabIndex="0">
                            <table>
                                <tbody>
                                    <tr>
                                        <td colSpan="4">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.summaryBoxSummary`} /></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.apr`} /></td>
                                        <td colSpan="3">
                                            <FormattedHTMLMessage
                                                id={`${LOCALE_PREFIX}.applyForBmlUk.aprDesc`}
                                                values={{
                                                    apr
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.otherInterestRates`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.introductoryRate`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.monthlyRate`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.annualRate`} /></td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.purchases`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.na`} /></td>
                                        <td>
                                            <FormattedHTMLMessage
                                                id={`${LOCALE_PREFIX}.applyForBmlUk.monthlyRatePurchases`}
                                                values={{
                                                    monthlyRate
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <FormattedHTMLMessage
                                                id={`${LOCALE_PREFIX}.applyForBmlUk.annualRatePurchases`}
                                                values={{
                                                    apr
                                                }}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.cashAdvances`} /></td>
                                        <td colSpan="3"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.naPPC`} /></td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.balanceTransfer`} /></td>
                                        <td colSpan="3"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.naPPC`} /></td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.promotionalOffer`} /></td>
                                        <td colSpan="3">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.promotionalOfferLine1`} /></p>
                                            <ul>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.promotionalOfferLine1Bullet1`} /></li>
                                                <li>
                                                    <FormattedHTMLMessage
                                                        id={`${LOCALE_PREFIX}.applyForBmlUk.promotionalOfferLine1Bullet2`}
                                                        values={{
                                                            offerThreshold
                                                        }}
                                                    />
                                                </li>
                                            </ul>
                                            <p>
                                                <FormattedHTMLMessage
                                                    id={`${LOCALE_PREFIX}.applyForBmlUk.promotionalOfferLine2`}
                                                    values={{
                                                        offerThreshold,
                                                        apr
                                                    }}
                                                />
                                            </p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestFreePeriod`} /></td>
                                        <td colSpan="3">
                                            <ul>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestDesc`} /></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestChargingInfo`} /></td>
                                        <td colSpan="3">
                                            <ul>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestChargingInfoBullet1`} /></li>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestChargingInfoBullet2`} /></li>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.interestChargingInfoBullet3`} /></li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPayments`} /></td>
                                        <td colSpan="3">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine1`} /></p>
                                            <ol className="upper-alpha">
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine1Bullet1`} /></li>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine1Bullet2`} /></li>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine1Bullet3`} /></li>
                                                <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine1Bullet4`} /></li>
                                            </ol>
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine2`} /></p>
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.allocationPaymentsLine3`} /></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepayment`} /></td>
                                        <td colSpan="3">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine1`} /></p>

                                            <div className="indent">
                                                <ol className="upper-alpha">
                                                    <li><p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine2`} /></p>
                                                        <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.plus`} />:</p></li>
                                                    <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine3`} />
                                                        <ol className="lower-roman">
                                                            <li>
                                                                <FormattedHTMLMessage
                                                                    id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine4`}
                                                                    values={{
                                                                        minimumRepayment
                                                                    }}
                                                                />
                                                            </li>
                                                            <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine5`} /></li>
                                                            <li>
                                                                <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine6`} /></p>
                                                                <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.plus`} />:</p>
                                                            </li>
                                                            <li><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine7`} /></li>
                                                        </ol>
                                                    </li>
                                                </ol>
                                            </div>
                                            <div><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.minimumRepaymentDescLine8`} /></div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question" rowSpan="2">
                                            <strong><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.amountCredit`} /></strong></td>
                                        <td colSpan="2"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.amountCreditDesc1`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.amountCreditDesc2`} /></td>
                                    </tr>
                                    <tr>
                                        <td colSpan="2"><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.amountCreditDesc3`} /></td>
                                        <td><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.amountCreditDesc4`} /></td>
                                    </tr>
                                    <tr>
                                        <td className="question"><strong><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.fees`} /></strong></td>
                                        <td colSpan="3">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.feesLine1`} /></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question"><strong><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.charges`} /></strong>
                                        </td>
                                        <td colSpan="3" className="feesCharges">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.chargesLine1`} /></p>

                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.chargesLine2`} /></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="question">
                                            <strong><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.defaultCharges`} /></strong></td>
                                        <td colSpan="3" className="feesCharges">
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.defaultChargesLine1`} /></p>
                                            <p><FormattedHTMLMessage id={`${LOCALE_PREFIX}.applyForBmlUk.defaultChargesLine2`} /></p>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(OutlineOfCredit);
